import { Location, LOCATIONS_QUERY_KEY } from './useLocations';
import { createCrudHooks } from '../utils/createCrudHooks';

const { useCreate, useUpdate, useDelete } = createCrudHooks<Location>({
  endpoint: '/api/locations',
  queryKey: LOCATIONS_QUERY_KEY,
  getId: l => l.locationid,
});

export const useCreateLocation = useCreate;
export const useUpdateLocation = useUpdate;
export const useDeleteLocation = useDelete;
